<template>
  <core-view class="core-view">
    <div class="container" >
      <div class="header-container">
            <div :class="{
                reset: true,
                compact: !showInfo,
              }">
                <table class="tableInfo">
                <tr
                class="table__tr table__tr--header cursor"
                @click="showInfo = !showInfo">
                  <th>
                    Produto
                  </th>
                  <th class="px-1">
                    UN
                  </th>
                  <th class="px-1">
                    Unidade
                  </th>
                  <th class="px-1">
                    Quantidade
                  </th>
                </tr>
                  <tr :class="{
                    'table__tr': true,
                    'table__tr--dark-background': false,
                    'hidetable': !showInfo
                    }"
                    :style="{pointerEvents: 'none'}">
                    <td>
                      {{$$_item.ociproduto}}
                    </td>
                    <td>
                      {{$$_item.ociun}}
                    </td>
                    <td>
                      -
                    </td>
                    <td>
                      {{FormataQuantVirgula($$_item.ociquantidade)}}
                    </td>
                  </tr>
                  <tr :class="{
                    'table__tr': true,
                    'table__tr--dark-background': true,
                    'hidetable': !showInfo
                    }"
                    :style="{pointerEvents: 'none'}">
                    <td>
                      UNIDADES CARREGADAS
                    </td>
                    <td>
                      -
                    </td>
                    <td>
                      {{$$_unidadesInseridas.length}}
                    </td>
                    <td>
                      {{FormataQuantVirgula(quantidadeUnidades)}}
                    </td>
                  </tr>
            </table>
            </div>
        </div>

        <div class="qr">
          <card-auto-complete ref="pesagem"
            label="Unidade a Carregar"
            class="textfield n-center my-10"
            :dados="dados" 
            :readonly="!dados"
            v-model="pesagem"
            itemLabel="approcontrole"  
            item-value="appidaberturalote"
            :return-object="true"
            no-data-text="Sem produção deste produto..."
            hide-details
            icon="mdi-qrcode-scan"
            :action="$_onClickQR"
            @keyup.enter="$_onEnterUnidade"
          />
          <v-select 
            outlined 
            :background-color="bags?.length > 0  ? 'white' : '#fdffd2'"
            label="Bag"
            :items="bags"
            :menu-props="{
              transition: 'scale-transition',
              rounded: 'lg',
              offsetY: true, bottom: true
            }"
            clearable
            clear-icon="mdi-close"
            item-text="appnumerobag"  
            item-value="appnumerobag"
            :class="{bag: bags?.length > 0  ? false : true }"
            class="numero-armazenamento sem-icone n-center my-10"
            v-model="bag"
            hide-details>
          </v-select>
        </div>

        <v-btn @click="$_inserir()" color="primary" class="salvar align-self-center"  width="125px">
          Confirmar
        </v-btn>
      <v-card class="my-10">
      <v-card-text class="table-container table-unidades" >
        <simplebar data-simplebar :autoHide="false" :style="{height: 100 + '%'}">
          <!-- <table :style="{ width: unidadesInseridas.length > 0 ? 100 + '%' : 100 + '%' }"> -->
          <table :style="{ width: 100 + '%' }">
            <tr class="table__tr--header" ref="simplebar">

              <th class="px-2">
                Ação
              </th>
              <th class="px-2">
                Lote
              </th>
              <th class="px-2">
                NU
              </th>
              <th class="px-2">
                Quantidade
              </th>
            </tr>
          
          <template v-for="(value, index) in $$_unidadesInseridas">
              <tr :class="{
                'table__tr': true,
                'table__tr--dark-background': index % 2 == 0,
                }"
                :key="index" >
                <td  >
                  <v-btn icon small @click="$_remover($$_unidadesInseridas[index])">
                    <v-icon small color="red">mdi-delete</v-icon>
                  </v-btn>
                </td >
                <td  >{{value.oculote}}</td >
                <td  v-if="value.ocunumerobag">{{value.ocunumerobag}}</td >
                <td  v-else>- - -</td >
                <td  >{{FormataQuantVirgula(value.ocuquantidade)}}</td >
              </tr>
          </template>
          
        </table>
        </simplebar>

      </v-card-text>

      <v-divider></v-divider>


      <v-dialog v-model="dialog" max-width="400px" @click:outside="$_clearHashRoute()">
      <v-card class="rounded-lg">
      <v-card-title class="header headline red white--text justify-space-between">
        <div class="header">
          Remover Unidade
        </div>
      </v-card-title>
      <div class="mx-4 my-auto">
        <v-card-text class="font-weight-small text-subtitle-1">
          Isso irá remover a unidade: <br>
          {{unidadeselecionada?.oculote}} - 
          {{unidadeselecionada?.ocunumerobag ? '  ' + unidadeselecionada?.ocunumerobag +  ' - ' : ''}}
          {{FormataQuantVirgula(unidadeselecionada?.ocuquantidade)}}
        </v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn plain class="mb-3 mt-1" @click="dialog = false, $_clearHashRoute()">Voltar</v-btn>
          <v-btn plain class="mb-3 mt-1 green--text" @click="$_remover(unidadeselecionada, !!$$_item.ocidatafinalizado)" >
            Remover
          </v-btn>
        </div>
      </div>
      </v-card>
    </v-dialog>
    </v-card>

    <v-btn v-if="!$$_item.ocidatafinalizado"
     color="primary" class="mx-auto" 
     @click="$_submit()" >
      <div v-if="!enviando">Processar Apontamento</div>
      <v-progress-circular v-else
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-btn>
    
     <validation-dialog
        v-model="validacaoFinalizar"
        tipo="alerta"
        :validacaoData="validacaoData"
        @validacaoContinuar="$_continuarFinalizar"
      />
    
    </div>
  </core-view>
</template>

<script>

import deepEquals from '@/utils/deep-equals';

import { getQueryValue, } from '@/services/query-string';

import { ABASTECIMENTO_QUERIES,  } from '@/constants/QUERY_FILTERS';

import { ROUTE_CADASTRO,  ROUTE_QR, ROUTE_ORDEM_CARREGAMENTO_UNIDADE, ROUTE_ORDEM_CARREGAMENTO } from '@/constants/ROUTES';

import { CADLOTE_STORAGE, OPLOCAL_STORAGE } from '@/constants/STORAGE';
import CardAutoComplete from '@/components/core/card-auto-complete-ordem/Index.vue'

import CoreView from '@/components/core/view/Index.vue';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

// import AppCardAtividadeSkeleton from '../../components/app/card/atividade/Skeleton.vue';
import moment from 'moment-timezone';
import { mapActions, mapMutations, mapState } from 'vuex';
import errorHandler from '@/utils/error-handler';
import geraData from '@/utils/geradata';
import db from '@/plugins/dexie';
// import db from '@/plugins/dexie';

import ValidationDialog from '@/components/app/dialog/ValidationDialog.vue';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default {
  name: 'ViewFrota',

  components: {
    CoreView,
    simplebar,
    CardAutoComplete,
    ValidationDialog,
  },


  data() {
    return {
      rotaFiltros: [
        ROUTE_CADASTRO, 
      ],

      loading: true,
      enviando: false,
      quantidadeUnidades: null,

      src: "/img/et.jpg",

      showInfo: true,
      pesagem: {},
      lotes: null,
      apontamento: null,
      dados: null,

      hash: null,
      bags: null,
      bag: null,
      LoteBagMap: null,
      dialog: false,
      unidadeselecionada: null,

      validacaoData: null,
      continuarProcesso: false,
      validacaoFinalizar: false,

      filters: {
        createdFrom: getSessionStorage(CADLOTE_STORAGE.createFrom, null),
        createdBefore: getSessionStorage(CADLOTE_STORAGE.createBefore, null),
      },
    };
  },
 
  computed: {
    ...mapState({
      $$_unidades: (state) => state.ordemcarregamento.unidades,
      $$_ordem: (state) => state.ordemcarregamento.ordem,
      $$_item: (state) => state.ordemcarregamento.itemAtual,
      $$_unidadesInseridas: (state) => state.ordemcarregamento.unidadesInseridas,
      $$_cacheLote: (state) => state.cache.cache_aberturalote,
      $$_cacheApontamento: (state) => state.cache.cache_apontamentoproducao,
      $$_cacheLocal: (state) => state.cache.cache_localarmazenamento,
      $$_cacheOrdem: (state) => state.cache.cache_ordemcarregamento,
      $$_cacheItem: (state) => state.cache.cache_ordemcarregamentoitem,
      $$_cacheUnidade: (state) => state.cache.cache_ordemcarregamentounidade,
    })
  },

  methods: {
     $_isEmpty(obj) {
      return !obj || Object.keys(obj).length === 0;
     },

    // Safari/iOS não tem navigator.vibrate.
    $_vibrar() {
      if (typeof navigator.vibrate === 'function') navigator.vibrate([200, 100, 200]);
    },

    ...mapActions({
      $_getCache: 'cache/getCache',
      $_reloadCache: 'cache/reloadCache',
      $_verificaUnidades: 'ordemcarregamento/verificaUnidades',
      $_verificaQuantidade: 'ordemcarregamento/verificaQuantidade'
    }),
    ...mapMutations({
      $_setUnidades: 'ordemcarregamento/SET_UNIDADES_INSERIDAS',
      $_addUnidades: 'ordemcarregamento/ADD_UNIDADES_INSERIDAS',
      $_delUnidades: 'ordemcarregamento/DEL_UNIDADES_INSERIDAS',
      $_atualizarItens: 'ordemcarregamento/SET_ITENS',
      $_atualizarOrdem: 'ordemcarregamento/SET_ORDEM',
      $_atualizarUnidadesPermitidas: 'ordemcarregamento/SET_UNIDADES',
      $_clearUnidades: 'ordemcarregamento/CLEAR_UNIDADES',
      $_adicionarCache: 'cache/PUSH_CACHE',
    }),

    async $_continuarFinalizar() {
      this.validacaoFinalizar = false;
      this.continuarProcesso = true;
      this.$_clearHashRoute();
      await this.$_submit(true);
    },
    
    async $_submit() {

      if (this.enviando) {
        return;
      }
      
      if (this.$$_item.ociverificaunidade === 'S') {
        const verificacao = await this.$_verificaUnidades({ 
          inseridas: this.$$_unidadesInseridas, 
          unidades: this.$$_unidades })

        console.log('item', verificacao)

        if (!verificacao.resultado) {
          console.log('diferenca', verificacao.diferencas);
          errorHandler('Não foram inseridas todas as unidades definidas.')
          return;
        }

        const validarQuantidade = await this.$_verificaQuantidade({
          quantidade: this.$$_item.ociquantidade,
          inseridas: this.$$_unidadesInseridas,
        })
        if (!validarQuantidade.resultado) {
          console.log('validar quantidade ein ', validarQuantidade, this.$$_item.ociquantidade)
          console.log(this.$$_unidadesInseridas,)
          errorHandler('Quantidade diferente da autorizada.')
          return;
        }
      } else  {
        if (!this.continuarProcesso) {
          const validarQuantidade = await this.$_verificaQuantidade({
            quantidade: this.$$_item.ociquantidade,
            inseridas: this.$$_unidadesInseridas,
          })
          if (!validarQuantidade.resultado) {
            this.validacaoData = [{
              item: this.$$_item,
              resultadoUnidades: {},
              resultadoQuantidade: validarQuantidade,
            }]
            this.validacaoFinalizar = true;
            return;
          }
        }
      }

        try {
          this.enviando = true;

          console.log('ISEMPTY', this.$_isEmpty(this.$$_unidades));
          let res;
          const modificacoes = [];
          
          console.log(this.$$_unidadesInseridas)
          this.$$_unidadesInseridas.map((u) => {
          modificacoes.push({
              key: u.id,
              changes: {
                ocudatafinalizado: geraData(),
                ocudatanuvem: null,
              }
            })
          })

          console.log('inseridas', this.$$_unidadesInseridas);
          console.log('unidades pro bulkadd', modificacoes);
          res = await db.ordemcarregamentounidade.bulkUpdate(modificacoes);
                    
          await db.ordemcarregamentoitem.update(this.$$_item.id, {
            ocidatafinalizado: geraData(),
            ocidatanuvem: null,
          });
          
          await this.$_reloadCache('ordemcarregamentounidade');
          await this.$_reloadCache('ordemcarregamentoitem');
                
          console.log(res, 'res');
          this.enviando = false;
          
          setTimeout(() => {
            this.$router.push({
              ...this.$route,
              name: ROUTE_ORDEM_CARREGAMENTO.name,
            });
          });

        } catch(e) {
          this.enviando = false;
          console.log(e, 'eeeee');
          if(e.code == 'ERR_NETWORK'){
            errorHandler('Erro de conexão');
          } else {
            errorHandler(e);
          }
        }
    },

    async $_setup() {
      this.loading = true;
      // const ablcache = await this.$_getCache('aberturalote');
      // const appcache = await this.$_getCache('apontamentoproducao');
      

      console.log(this.$$_item);
      const lotes = this.$$_cacheLote.filter((lot) => {
        // console.log(lot.ablidproduto, this.$_item.ociidproduto)
        if (lot.ablidproduto === this.$$_item.ociidproduto) return lot;
      });
      const lotesMap = new Map(lotes.map((item) => [item.ablidaberturalote, item]));


      let dados = [];
      const dadosMap = new Map();
      this.$$_cacheApontamento.filter((app) => {
        const loteInfo = lotesMap.get(app.appidaberturalote);
        if (loteInfo?.ablidproduto === this.$$_item.ociidproduto) {
          if (!dadosMap.has(app.appidaberturalote)) {
            dadosMap.set(app.appidaberturalote, 
            {
              appdescricao: loteInfo.abldescricao,
              appgranulometria: loteInfo.ablgranulometria,
              appidproduto: loteInfo.ablidproduto,
              appnrocontrole: loteInfo.ablnrocontrole,
              appdatapesagem: app?.appdatapesagem,
              appidaberturalote: app?.appidaberturalote,
              appidlocalmovimentacaoestoque: app?.appidlocalmovimentacaoestoque,
              appnumerobag: app?.appnumerobag ?? 0,
              apppeso: app?.apppeso
            });

            if (app.appnumerobag) {
              const mapGet = dadosMap.get(app.appidaberturalote);
              mapGet.bags = [];
              mapGet.bags.push({
                appdescricao: loteInfo.abldescricao,
                appgranulometria: loteInfo.ablgranulometria,
                appidproduto: loteInfo.ablidproduto,
                appnrocontrole: loteInfo.ablnrocontrole,
                appdatapesagem: app?.appdatapesagem,
                appidaberturalote: app?.appidaberturalote,
                appidlocalmovimentacaoestoque: app?.appidlocalmovimentacaoestoque,
                appnumerobag: app?.appnumerobag,
                apppeso: app?.apppeso  
              })

              dadosMap.set(app.appidaberturalote, mapGet);
              }
          // } else if (app.appnumerobag) {
          } else {
            // console.log(Array.isArray(dadosMap.get(app.appidaberturalote)) ?? [dadosMap.get(app.appidaberturalote)])
            // console.log([dadosMap.get(app.appidaberturalote)]);
            // const mapGet = Array.isArray(dadosMap.get(app.appidaberturalote)) ? dadosMap.get(app.appidaberturalote) : [dadosMap.get(app.appidaberturalote)];
            const mapGet = dadosMap.get(app.appidaberturalote);
            // console.log(typeof mapGet, Array.isArray(mapGet), mapGet)
            if (!mapGet.bags) mapGet.bags = [];
            mapGet.bags.push({
              appdescricao: loteInfo.abldescricao,
              appgranulometria: loteInfo.ablgranulometria,
              appidproduto: loteInfo.ablidproduto,
              appnrocontrole: loteInfo.ablnrocontrole,
              appdatapesagem: app?.appdatapesagem,
              appidaberturalote: app?.appidaberturalote,
              appidlocalmovimentacaoestoque: app?.appidlocalmovimentacaoestoque,
              appnumerobag: app?.appnumerobag,
              apppeso: app?.apppeso  
            })

            dadosMap.set(app.appidaberturalote, mapGet);
          }
        }
      })
      const bags = [];
      dadosMap.forEach((item) => {
        dados.push(item);
        if (item.length > 1) bags.push(item);
      })
      
      this.dados = dados;
      this.quantidadeUnidades = 0
      
    },


    $_FormataDataGeral(date) {
      // console.log(date);
      return moment.utc(date).format('DD/MM/YYYY HH:mm');
    },

    FormataQuantVirgula(valor) {
      // Peso sem decimais (trunca), com separador de milhar
      return Math.trunc(Number(valor) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 0 });
    },

    // ENTER (desktop) ou "Inserir" (teclado mobile): texto digitado sem lote correspondente na ordem.
    $_onEnterUnidade() {
      const autocomplete = this.$refs.pesagem.$refs.focusinput;
      const busca = autocomplete.internalSearch?.trim();
      if (busca && !autocomplete.filteredItems.length) {
        this.$_vibrar();
        errorHandler('Unidade não relacionada à esta ordem.');
      }
      autocomplete.blur();
    },

    $_onClickQR() {
      sessionStorage.setItem('rota-anterior', ROUTE_ORDEM_CARREGAMENTO_UNIDADE.path);
      setTimeout(() => {
        this.$router.push({
          ...this.$route,
          name: ROUTE_QR.name,
        });
      });
    },

    async $_verificaQR() {
      const qr = await getSessionStorage(OPLOCAL_STORAGE.qr, '');
      const numerobag = await getSessionStorage(OPLOCAL_STORAGE.numerobag, '');

      console.log('qr', qr, 'nbag', numerobag);

      if (qr && qr.length && qr !== 'null') {
        const pesagem  = this.dados.find((pes) => pes.appnrocontrole === qr);
        if (!pesagem || !Object.entries(pesagem)?.length) {
          this.$_vibrar();
          errorHandler('Unidade não relacionada à esta ordem.');
          sessionStorage.removeItem('qr');
          sessionStorage.removeItem(OPLOCAL_STORAGE.numerobag);
          return;
        }
        this.pesagem = pesagem;
        if (numerobag) {
          // QR traz o bag como texto ("01"); usa o valor do item para o v-select casar.
          const bagLido = [pesagem, ...(pesagem.bags ?? [])].find((b) => b.appnumerobag && Number(b.appnumerobag) === Number(numerobag));
          this.bag = bagLido?.appnumerobag ?? null;
          if (!bagLido) errorHandler('Número Bag não encontrado');
        }
      }

      sessionStorage.removeItem('qr');
      sessionStorage.removeItem(OPLOCAL_STORAGE.numerobag);
    },

    async $_inserir() {
      if (this.$_isEmpty(this.pesagem)) return;
      let unidade;
      let dbunidade;
      if (this.$$_item.ociverificaunidade === 'S') {
        console.log('Possui verificação de unidade');
        
        

        const criarChave = (b) => {
          const abertura = b?.ocuidaberturalote ?? b?.appidaberturalote;
          const bag = b?.ocunumerobag ?? b?.appnumerobag;
          return `${abertura}-${bag}`;
        };

        const unidadesMap = new Map(this.$$_unidades.map((item) => [criarChave(item), item]));

          console.log('nrobsag', this.pesagem.appnumerobag)
        if (this.pesagem.bags) {
          console.log('combag', this.bag, this.bags)
          unidade = unidadesMap.get(criarChave({
            appidaberturalote: this.pesagem.appidaberturalote,
            appnumerobag: this.bag
            })
          );
        } else {
          console.log('sembag')
          unidade = unidadesMap.get(criarChave(this.pesagem));
        }
        
        console.log('pesagem', this.pesagem);
        console.log('existe nas unidade', unidade);
        console.log('chave q ta indo', `${this.pesagem.appidaberturalote}-${this.bag}`)
        console.log('o map', unidadesMap);  

               
        console.log('bagsMap', this.LoteBagMap)
        console.log('a bag do map', this.LoteBagMap?.get(`${this.pesagem.appidaberturalote}-${this.bag}`))
        if (!unidade)  {
          this.$_vibrar();
          errorHandler('Esta unidade não é permitida.');
          return;
        }
        
        const [jaIncluso] = this.$$_unidadesInseridas.filter(
          (item) => item.ocuidaberturalote === unidade.ocuidaberturalote && item.ocunumerobag === unidade.ocunumerobag); 
        
        console.log('Incluso', jaIncluso);


        if (jaIncluso) {
          this.$_vibrar();
          errorHandler('Unidade já foi inserida');
          return;
        }

        await db.ordemcarregamentounidade.update(unidade.id, {
          ocudatacriacao: geraData(),
          ocudatanuvem: null,
        })

        dbunidade = unidade.id;
        await this.$_reloadCache('ordemcarregamentounidade');
      } else {
        console.log('Sem verificação de unidade')

        console.log(this.pesagem.appidaberturalote, this.bag);
        console.log(this.LoteBagMap?.get(`${this.pesagem.appidaberturalote}-${this.bag ?? 0}`));
        const loteBag = this.LoteBagMap?.get(`${this.pesagem.appidaberturalote}-${this.bag ?? 0}`);
        const criarChave = (b) => `${b.appidaberturalote}-${b.appnumerobag}`;
        console.log('chave', criarChave(this.pesagem), this.pesagem, loteBag);
 
        const local = this.$$_cacheLocal.find((l) => (l.loaidlocalarmazenamento === loteBag?.appidlocalmovimentacaoestoque) || (l.loaidlocalarmazenamento === this.pesagem?.appidlocalmovimentacaoestoque));
        console.log('local', local);
         
        if (loteBag) {
          unidade = {
            ocuidaberturalote : loteBag?.appidaberturalote,
            ocuidlocalmovimentacaoestoque : loteBag?.appidlocalmovimentacaoestoque,
            ocuidordemcarregamentoitem : this.$$_item.ociidordemcarregamentoitem,
            oculocal : local?.loacodigoarmazem,
            oculote : loteBag.appnrocontrole, 
            ocuquantidade : loteBag.apppeso,
            ocunumerobag: loteBag.appnumerobag,
          }
        } else  {
          unidade = {
            ocuidaberturalote : this.pesagem.appidaberturalote,
            ocuidlocalmovimentacaoestoque : this.pesagem.appidlocalmovimentacaoestoque,
            ocuidordemcarregamentoitem : this.$$_item.ociidordemcarregamentoitem,
            oculocal : local?.loacodigoarmazem,
            oculote : this.pesagem.appnrocontrole, 
            ocuquantidade : this.pesagem.apppeso,
            ocunumerobag: this.pesagem.appnumerobag,
          }
        }

        console.log('unidade', unidade);
        console.log(loteBag, 'pesagem no qr', this.pesagem);
        console.log('inseridas', this.$$_unidadesInseridas);
                
        // if (!unidade)  {
        //   errorHandler('Esta unidade não é permitida.');
        //   return;
        // }
        
        const [jaIncluso] = this.$$_unidadesInseridas.filter(
          (item) => item.ocuidaberturalote === unidade.ocuidaberturalote && item.ocunumerobag === unidade.ocunumerobag);        
        console.log('Incluso', jaIncluso);


        if (jaIncluso) {
          this.$_vibrar();
          errorHandler('Unidade já foi inserida');
          return;
        }
        const novaUnidade = {
          ocuidaberturalote: unidade?.ocuidaberturalote,
          oculote: unidade?.oculote,
          oculocal: unidade?.oculocal,
          ocuidlocalmovimentacaoestoque: unidade?.ocuidlocalmovimentacaoestoque,
          ocuidordemcarregamentoitem: unidade?.ocuidordemcarregamentoitem,
          ocunumerobag: unidade?.ocunumerobag,
          ocuquantidade: unidade?.ocuquantidade,
          ocudatacriacao: geraData(),
          ocudatanuvem: null,
          ocuidnuvem: 'null',
          ocuorigem: 'W',
          ocudatafinalizado: null,
        };
        
        console.log('novaUnidade', novaUnidade);
        dbunidade = await db.ordemcarregamentounidade.add(novaUnidade);
        if (dbunidade) this.$_adicionarCache({tabela: 'ordemcarregamentounidade', novosItens: [{ ...novaUnidade, id: dbunidade }]});
        console.log('dbunidade', dbunidade)
      }

      if (this.$$_item.ocidatafinalizado) {
        console.log('ele ta batendo como se tivesse finalizado');
        this.$$_item.ocidatafinalizado = null;
        await db.ordemcarregamentoitem.update(this.$$_item.id, {
          ocidatafinalizado: null,
          ocidatanuvem: null,
        })
        const modificacoes = [];
        this.$$_unidadesInseridas.map((u) => {
          modificacoes.push({
              key: u.id,
              changes: {
                ocudatafinalizado: null,
                ocudatanuvem: null,
              }
            })
          })
        await db.ordemcarregamentounidade.bulkUpdate(modificacoes);
        this.$_reloadCache('ordemcarregamentoitem');
      }
      
      this.$nextTick(() => {
        this.$_addUnidades({...unidade, id: dbunidade});
        // this.unidadesInseridas.push(unidade);
        this.pesagem = null;
        this.quantidadeUnidades += Number(unidade.ocuquantidade)
        console.log(this.quantidadeUnidades);
        
        console.log('if do salvar', this.$$_item.quantidade, this.quantidadeUnidades ,Number(this.$$_item.ociquantidade) === Number(this.quantidadeUnidades));
      })
      

      // SetupEnvioLocal();
    },

    async $_remover(unidade, estavaFinalizado) {
      if (!this.dialog) {
        this.dialog = true;
        this.unidadeselecionada = unidade;
        window.location.hash = '#remover'
        return;
      }

      console.log('processo remoção', unidade, estavaFinalizado);
      if (estavaFinalizado) {
        this.$$_item.ocidatafinalizado = null;
        await db.ordemcarregamentoitem.update(this.$$_item.id, {
          ocidatafinalizado: null,
          ocidatanuvem: null,
        })
        // this.$_setUnidades(this.$$_unidades);
        const modificacoes = [];
        this.$$_unidadesInseridas.map((u) => {
          modificacoes.push({
              key: u.id,
              changes: {
                ocudatafinalizado: null,
                ocudatanuvem: null,
              }
            })
          })
        await db.ordemcarregamentounidade.bulkUpdate(modificacoes);
        await db.ordemcarregamentounidade.update(unidade.id, {
          ocudatacriacao: null,
        })
        // Senão a tela da O.C. continua vendo o item finalizado.
        await this.$_reloadCache('ordemcarregamentoitem');
        // this.$_clearUnidades(); // Unidades que já estavam inseridas.
      }
      const dbunidade = await db.ordemcarregamentounidade.where({id: unidade.id});
      const dbunidadeGet = await dbunidade.first();
      console.log(dbunidadeGet, unidade, this.unidadeselecionada)
      console.log(!dbunidadeGet?.ocuidnuvem, 'semidnuvem');
      if (dbunidadeGet?.ocuorigem === 'D') {
        await db.ordemcarregamentounidade.update(unidade.id, {
          ocudatacriacao: null,
          ocudatafinalizado: null,
          ocudatanuvem: null,
        })
      } else if (dbunidadeGet.ocuidnuvem !== 'null') {
        await db.ordemcarregamentounidade.update(unidade.id, {
          ocudatacriacao: null,
          ocuexclusao: 'S',
          ocudatafinalizado: null,
          ocudatanuvem: null,
        })
      } else {
        await dbunidade.delete();
      }
      // se tiver idnuvem, salva numa tabela logexclusaoweb para excluir lá em cima tbm
      // const index = this.unidadesInseridas.findIndex((item) => item.ocuidordemcarregamentounidade === unidade.ocuidordemcarregamentounidade);
      
      this.$nextTick(async () => {
        await this.$_reloadCache('ordemcarregamentounidade');
        // this.unidadesInseridas.splice(index, 1);
        const unidades = this.$$_cacheUnidade.filter((u) => 
        (u.ocuidordemcarregamentoitem === this.$$_item.ociidordemcarregamentoitem && u.ocuorigem === 'D')
        || 
        (u.ocuidordemcarregamentoitem === this.$$_item.ociidordemcarregamentoitem && u.ocudatafinalizado));
        
        // Precisa atualizar senão não consegue re-inserir a deletada, aparece algo que o objeto ja não é o mesmo.
        if (estavaFinalizado) this.$_atualizarUnidadesPermitidas(unidades);
        
        this.$_delUnidades(unidade);
        console.log('novasinseridas', this.$$_unidadesInseridas);
        this.quantidadeUnidades -= unidade.ocuquantidade;
        this.dialog = false;
        this.$_clearHashRoute();
      })
    },

    async $_clearHashRoute() {
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
        hash: '',
      }).catch(() => {});
    },
  },

  created() {
    // this.$_load();
    if (sessionStorage.getItem(OPLOCAL_STORAGE.qr)) this.$_verificaQR();
    if (!this.$_isEmpty(this.$$_unidadesInseridas)) {
      this.$nextTick(() => {
        // this.unidadesInseridas = this.unidadesInseridas;
          this.quantidadeUnidades = this.$$_unidadesInseridas.reduce((acc, curr) => acc + Number(curr.ocuquantidade), 0);       
        })
    } 
    this.$_setup();
    console.log(this.$$_unidades);
  },

  async beforeRouteLeave(to, from, next) {
    console.log('ROYTE', this.$route);
    setTimeout(async () => {
      if (this.$route?.hash) {
        this.dialog = false;
        this.$_clearHashRoute();
      } else {
        next();
      }
    }, 0);
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        if (this.$route?.hash) {
          if (this.$route?.hash === '#remover') {
            this.dialog = true;
          } 
        } else {
          this.dialog = false;
        }

        const filters = {
          createdFrom: getQueryValue(ABASTECIMENTO_QUERIES.createdFrom, this.filters.createdFrom),
          createdBefore: getQueryValue(
            ABASTECIMENTO_QUERIES.createdBefore,
            this.filters.createdBefore,
          ),
        };

        if (!deepEquals(this.filters, filters)) {
          this.filters.createdFrom = filters.createdFrom;
          this.filters.createdBefore = filters.createdBefore;

          if (this.$refs.lista) {
            this.$_load();   
          }
        }
      },
    },

    pesagem: {
      deep: true,
      handler() {
        console.log('pesagem', this.pesagem);
        console.log('bags', this.bags);
        if (this.pesagem?.bags) {
          console.log('numerobag not null', this.pesagem.bags.filter((i) => i.appnumerobag !== null))
          const bagsValidas = this.pesagem.bags.filter((i) => i.appnumerobag !== null);
          //if (!this.pesagem.appnumerobag) this.pesagem.appnumerobag = 0;
          // tem q ver para qnd os numerobag for nulo, só aparecer 0 ou nem aparecer, sei lá
          // console.log('valida', bagsValidas.length > 0,bagsValidas.length > 0 ? [this.pesagem, ...this.pesagem.bags] : [this.pesagem]);
          const bags = bagsValidas.length > 0 ? [this.pesagem, ...this.pesagem.bags] : [this.pesagem];
          const criarChave = (b) => `${b.appidaberturalote}-${b.appnumerobag}`;
          this.LoteBagMap = new Map(bags.map((b) => [criarChave(b), b]))
          console.log('bags', bags);
          console.log(this.LoteBagMap);
          this.$nextTick(() => {
            // Bag pode ser texto ("01") ou número.
            this.bags = bags.filter((x) => x.appnumerobag !== 0).sort((a, b) => Number(a.appnumerobag) - Number(b.appnumerobag));
            // console.log('uni', this.$$_unidades,  Object.entries(this.$$_unidades).length === 0);
            // console.log('bag', this.bags?.length > 0 );
            // console.log(this.bags?.length > 0 && Object.entries(this.$$_unidades).length === 0 ? false : true);
          })
        } else {
          this.bags = null;
          this.bag = null;
          this.LoteBagMap = null;
        }
      },
    },
  },
};
</script>

<style scoped>
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }
  
    .core-view {
        height: max-content;
        width: 500px;
    }
  .container{
    display: flex;
    height: 100%;
    flex-direction: column;
  }

  .card-wrapper {
    display: flex;
    margin: 0px;
  }

  .icon {
    height: 70px;
  }

  .linha-aberto {
    background-color: #4CAF50;
    color: white;
  }

  .linha-fechado {
    background-color: #c0372e;
    color: white;
  }

  .linha-menor {
    height: 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px 0px 4px;
    font-size: 13px;
  }

  .card-secador {
    width: 40vw;
    text-align: center;
    margin: 10px;
  }

  .numero {
    font-size: 22px;
  }

  .card {
    width:  100%;
    text-align: center;
    margin: 10px;
  }

  .card_title {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 1.1em;
    height: fit-content;
    padding: 0.2rem;
    background-color: #4CAF50;
    color: white;
  }

  .card_detalhes {
    display: block;
    text-align: left;
  }

  .card_detalhes span:nth-of-type(odd) {
   background-color: #f5f5f5; 
  }

  .card_detalhes span:nth-of-type(even) {
    background-color: #e0e0e0; 
  }

.header-container {
  width: 100%;
  padding: 5px;
  background-color: white;
}

.header-container tr {
  display: flex;
  width: 100%;
}
.header-container th {
  flex: 1;
  text-align: center;
}
.table__tr > td {
  text-align: center;
  padding-block: 2px;
  font-size: 0.85rem;
}

.tableInfo {
  width: 100%;
}
.table {
  width: max-content;
}

.table__tr {
  transition: transform 0.2s;
  /* // border: 1px solid red; */
}

.table__tr:not(.table__tr--header):hover {
  background-color: #d9dee6;
  cursor: pointer;
}

.table__tr--dark-background {
  background-color: #eee;
}

.table__tr--header {
  background-color: #4CAF50;
  color: white;
}
.reset {
  transition: max-height 0.2s ease;
  max-height: 400px;
}

.reset tr:first-child {
  display: table-row;
  width: 100%;
}

.reset tr:not(:first-child) {
  display: table-row;
  width: 100%;
}
.compact {
  max-height: 40px;
  overflow: hidden;
}

.hidetable {
  transform: scaleY(0%);
  transform-origin: top;
}

@media screen and (min-width: 1000px ) {
  .table-container {
    overflow: hidden !important;
  }
}
.table-container {
  width: 100%;
  overflow: scroll;
  padding: 0px;
}
.numero-armazenamento {
  width: 10%;
}

.texfield {
  width: 100%;
}

  .n-center >>> input {
      text-align: center;
  }

  .n-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
.qr {
  max-width: 500px;
  display: flex;
}

.table-unidades {
  height: 15em;
  overflow-y: scroll;
  background-color: #ffffff;
}

.bag {
  pointer-events: none;
}

/deep/ .simplebar-scrollbar::before{
  background-color: #4CAF50 !important;
}
/deep/ .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}
/deep/ .sem-icone .v-input__icon--append,
/deep/ .sem-icone .v-select__selections input{
  display: none !important;
  width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
/deep/ .sem-icone .v-select__selections div {
  margin: auto !important;
}
</style>
